import { createSlice } from '@reduxjs/toolkit'

// Function to get initial language from URL path
const getInitialLanguage = () => {
  if (typeof window !== 'undefined') {
    const path = window.location.pathname.split('/')[1] // Get first path segment
    const supportedLanguages = ['en', 'ar'] // Add more if needed

    return supportedLanguages.includes(path) ? path : 'en' // Default to 'en' if not supported
  }

  return 'en' // Default for SSR
}

const initialState = {
  current: getInitialLanguage()
}

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.current = action.payload
    }
  }
})

export const { setLanguage } = languageSlice.actions
export default languageSlice.reducer
